import * as yup from 'yup';

import { Organization } from 'api/organizations/organizations.types';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { findAllByKey } from 'helpers/findAllByKey';

export const useOrganizationDetailsValidation = (
  mainOrganization: Organization,
  organizationFromDetails: Organization,
) => {
  const { formatMessage } = useLocale();
  const allOrganizationCodesWithoutSelectedStandarized = findAllByKey(mainOrganization, 'kod')
    .map((code) => code.toLowerCase())
    .filter((code) => code !== organizationFromDetails.kod.toLowerCase());

  const schema = yup.object().shape({
    kod: yup
      .string()
      .max(6, formatMessage({ id: AppMessages['definitions.organization.validation.code'] }))
      .test(
        'check organization code duplicate',
        formatMessage({ id: AppMessages['definitions.organization.add.name.validation'] }),
        (code) => !(code && allOrganizationCodesWithoutSelectedStandarized.includes(code.toLowerCase())),
      )
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    nazwa: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['definitions.organization.validation.name'] }))
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
  });
  return { schema };
};
